var _defs, _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#434345;isolation:isolate;opacity:0.01;}.cls-2{fill:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 96,
    height: 96
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72,48h0a4,4,0,0,0,4,4h8a4,4,0,0,0,4-4h0a4,4,0,0,0-4-4H76A4,4,0,0,0,72,48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.18,72.8l6.46,4.83a3.94,3.94,0,0,0,5.53-.79l0-.07a4,4,0,0,0-.79-5.54L72,66.39a4,4,0,0,0-5.55.81l-.05.06A4,4,0,0,0,67.18,72.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2,19.21h0a4,4,0,0,0-5.6-.81L67.2,23.2a4,4,0,0,0-.8,5.6h0a4,4,0,0,0,5.6.81l6.4-4.8A4,4,0,0,0,79.2,19.21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.11,34A9.11,9.11,0,0,0,8,43.09v9.08a9.11,9.11,0,0,0,9.08,9.08h4.54V77.14a2.27,2.27,0,0,0,2.27,2.27h3.54a2.27,2.27,0,0,0,2.27-2.27V61.25h5.54L54.53,72.8A2.27,2.27,0,0,0,58,70.86V24.4a2.27,2.27,0,0,0-3.44-1.95L35.27,34ZM40,40.77l9.94-5.36V59.84L40,54.48l-2.18-1.31H16.11V42.09H37.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default __webpack_public_path__ + "static/media/promotion.e962c1e4b5e0a7facc073faae84241e2.svg";
export { ForwardRef as ReactComponent };